/**
 * AC-798: default DISPLAY currency by GeoIP country for new visitors.
 * Separate from COUNTRY_TO_CURRENCY in cashierCurrencies.tsx on purpose —
 * that map is about PAYMENT RAILS (which bank tab to offer), this one is
 * about what currency to show balances in. Domain = the 9-currency array the
 * backend returns from /api/v1/profile/balance.
 */

/**
 * Front-end allow-list of display currencies. Since 2026-08-19 the full
 * backend display-fiat set is enabled; the gate stays as the kill-switch —
 * to disable a currency, comment its line here (and its country row below;
 * EUR is driven by the EUROZONE set), no other change needed.
 */
export const ENABLED_DISPLAY_CURRENCIES: ReadonlySet<string> = new Set([
    'USD',
    'EUR',
    'PYG',
    'BRL',
    'MXN',
    'PEN',
    'ARS',
    'BOB',
    'CLP',
]);

export const isDisplayCurrencyEnabled = (code: string | null | undefined): boolean =>
    !!code && ENABLED_DISPLAY_CURRENCIES.has(code.toUpperCase());

const EUROZONE = new Set([
    'AT', 'BE', 'CY', 'DE', 'EE', 'ES', 'FI', 'FR', 'GR',
    'HR', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PT', 'SI', 'SK',
]);

const DISPLAY_COUNTRY_TO_CURRENCY: Record<string, string> = {
    AR: 'ARS',
    BO: 'BOB',
    BR: 'BRL',
    CL: 'CLP',
    MX: 'MXN',
    PE: 'PEN',
    PY: 'PYG',
};

export const getDisplayCurrencyByCountry = (country: string | undefined | null): string => {
    if (!country) return 'USD';
    const code = country.toUpperCase();
    const mapped = EUROZONE.has(code) ? 'EUR' : DISPLAY_COUNTRY_TO_CURRENCY[code];
    return mapped && isDisplayCurrencyEnabled(mapped) ? mapped : 'USD';
};
